module.exports = __webpack_public_path__ + "img/salesman_registration_titleBg.b52edb89.png";